// project-imports
import {
  ADD_COURSE_COMMENT_BEGIN,
  ADD_COURSE_COMMENT_FAILURE,
  ADD_COURSE_COMMENT_SUCCESS,
  DELETE_COURSE_COMMENT_BEGIN,
  DELETE_COURSE_COMMENT_FAILURE,
  DELETE_COURSE_COMMENT_SUCCESS,
  GET_COURSE_COMMENT_BEGIN,
  GET_COURSE_COMMENT_FAILURE,
  GET_COURSE_COMMENT_SUCCESS,
  GET_COURSE_USER_REACTION_BEIGN,
  GET_COURSE_USER_REACTION_FAILURE,
  GET_COURSE_USER_REACTION_SUCCESS,
  GET_COURSES_BEGIN,
  GET_COURSES_FAILURE,
  GET_COURSES_SUCCESS,
  GLOBAL_SEARCH_COURSES_FAILURE,
  GLOBAL_SEARCH_COURSES_SUCCESS,
  PUT_COURSE_LIKES_BEGIN,
  PUT_COURSE_LIKES_FAILURE,
  PUT_COURSE_LIKES_SUCCESS,
  SET_USER_REACTION_BEGIN,
  SET_USER_REACTION_FAILURE,
  SET_USER_REACTION_SUCCESS,
  UPDATE_COURSE_COMMENT_BEGIN,
  UPDATE_COURSE_COMMENT_FAILURE,
  UPDATE_COURSE_COMMENT_SUCCESS,
} from "../constants/actions";
import { processCourseComments } from "../utils/course";

// State variable initialization
export const initialState = {
  coursesLoading: false,
  coursesError: null,
  courses: [],
  allComments: [],
  comments: [],
  featuredCourses: [],
  filteredCourses: [],
  courseAllUserReactions: [],
  courseUserReactionsCount: [],
  searchTerm: null,
};

const coursesReducer = (state = initialState, action) => {

  if (action.type === GET_COURSES_BEGIN) {
    // Set loading state
    return {
      ...state,
      coursesLoading: true,
      coursesError: null,
      searchTerm: null,
    };
  }

  if (action.type === GET_COURSES_SUCCESS) {
    let data = [];
    let existingCourses = [...state.courses];

    ([...action.payload] || []).forEach((item) => {
      existingCourses = existingCourses.filter(
        (dataItem) => dataItem.id !== item.id
      );
      item.link = item.title;
      data.push(item);
    });

    // Update state with new courses
    return {
      ...state,
      coursesError: null,
      coursesLoading: false,
      filteredCourses: [],
      courses: JSON.parse(JSON.stringify(data)),
      searchTerm: null,
    };
  }

  if (action.type === GET_COURSES_FAILURE) {
    // Set error state
    return {
      ...state,
      coursesLoading: false,
      courses: [],
      coursesError: action.payload,
      searchTerm: null,
    };
  }

  if (action.type === PUT_COURSE_LIKES_BEGIN) {
    // Set loading state
    return {
      ...state,
      coursesLoading: action.payload,
      coursesError: null,
      searchTerm: null,
    };
  }

  if (action.type === PUT_COURSE_LIKES_SUCCESS) {

    const existingPosts = state.courses || [];

    const updatedCourses = existingPosts.map((course) => {
      if (action.payload && action.payload.success && course?.id === action?.payload?.success[0]?.id) {
        return { ...course, likes: action?.payload?.success[0]?.likes };
      }
      return course;
    });

    const featuredCourses = updatedCourses.filter(
      (course) => course.featured === true
    );

    // Update state with likes
    return {
      ...state,
      coursesError: null,
      coursesLoading: false,
      filteredCourses: [],
      courses: JSON.parse(JSON.stringify(updatedCourses)),
      searchTerm: null,
      featuredCourses
    };
  }

  if (action.type === PUT_COURSE_LIKES_FAILURE) {
    // Set error state
    return {
      ...state,
      coursesLoading: false,
      coursesError: action.payload,
      searchTerm: null,
    };
  }

  if (action.type === GET_COURSE_COMMENT_BEGIN) {
    // Set loading state
    return {
      ...state,
      coursesLoading: action.payload,
      coursesError: null
    };
  }

  if (action.type === GET_COURSE_COMMENT_SUCCESS) {

    const processedComments = processCourseComments(Array.isArray(action.payload) ? action.payload : []);

    // Update state with all comments 
    return {
      ...state,
      coursesLoading: false,
      coursesError: !Array.isArray(action.payload) ? action.payload : null,
      comments: processedComments,
      allComments: action.payload
    };

  }

  if (action.type === GET_COURSE_COMMENT_FAILURE) {
    // Set error state
    return {
      ...state,
      coursesLoading: false,
      coursesError: action.payload,
    };
  }

  if (action.type === ADD_COURSE_COMMENT_BEGIN) {
    // Set loading state
    return {
      ...state,
      coursesLoading: true,
      coursesError: null
    };
  }

  if (action.type === ADD_COURSE_COMMENT_SUCCESS) {

    let existingComments = Array.isArray(state?.allComments) ? [...(state?.allComments || [])] : [];
    let successRecords = action?.payload?.success || [];
    let statusCode = action?.payload?.statusCode || 500;
    let errors = action?.payload?.failures?.errors || [];
    let updatedComments = [...existingComments, ...successRecords];

    updatedComments = updatedComments.map(comment =>
      comment.id === successRecords?.id ? { ...successRecords } : comment
    );

    if (action?.payload?.id && !updatedComments.some(c => c.id === successRecords?.id)) {
      updatedComments.push(action?.payload?.success);
    }

    const processedComments = processCourseComments([...updatedComments]);

    // Update state with new comments
    return {
      ...state,
      coursesLoading: false,
      coursesError: statusCode !== 200 ? (errors || []).map(item => item.message).join(",") : [],
      comments: processedComments,
      allComments: updatedComments,
    };
  }

  if (action.type === ADD_COURSE_COMMENT_FAILURE) {
    // Set error state
    return {
      ...state,
      coursesLoading: false,
      coursesError: action.payload,
    };
  }

  if (action.type === UPDATE_COURSE_COMMENT_BEGIN) {
    // Set loading state
    return {
      ...state,
      coursesLoading: true,
      coursesError: null
    };
  }

  if (action.type === UPDATE_COURSE_COMMENT_SUCCESS) {

    let existingComments = [...(state.allComments || [])];
    let successRecords = action?.payload?.success || [];
    let statusCode = action?.payload?.statusCode || 500;
    let errors = action?.payload?.failures?.errors || [];

    const updatedComments = (successRecords ? successRecords : []).reduce((acc, item) => {
      const index = acc.findIndex((post) => post.id === item.id);
      if (index !== -1) {
        acc[index] = item;
      } else {
        acc.push(item);
      }
      return acc;
    }, [...existingComments]);

    const processedComments = processCourseComments([...updatedComments]);

    // Update state with updated comments
    return {
      ...state,
      coursesLoading: false,
      coursesError: statusCode !== 200 ? (errors || []).map(item => item.message).join(",") : [],
      comments: processedComments,
      allComments: updatedComments,
    };
  }

  if (action.type === UPDATE_COURSE_COMMENT_FAILURE) {
    // Set error state
    return {
      ...state,
      coursesLoading: false,
      coursesError: action.payload,
    };
  }

  if (action.type === DELETE_COURSE_COMMENT_BEGIN) {
    // Set loading state
    return {
      ...state,
      coursesLoading: action.payload,
      coursesError: null
    };
  }

  if (action.type === DELETE_COURSE_COMMENT_SUCCESS) {

    let existingComments = [...(state.allComments || [])];
    let updatedComments = [];

    if (action?.payload?.id) {
      updatedComments = existingComments.filter((item) => item.id !== action?.payload?.id)
    }

    const processedComments = processCourseComments([...updatedComments]);

    // Update state with deleted comments 
    return {
      ...state,
      coursesLoading: false,
      coursesError: null,
      comments: processedComments,
      allComments: updatedComments
    };

  }

  if (action.type === DELETE_COURSE_COMMENT_FAILURE) {
    // Set error state
    return {
      ...state,
      coursesLoading: false,
      coursesError: action.payload,
    };
  }

  if (action.type === GLOBAL_SEARCH_COURSES_SUCCESS) {

    let filteredCourses = [];
    let newTitle = "";
    const searchTerm = action.payload;
    let localState = state;

    // filtering search bar

    if (searchTerm && localState) {
      filteredCourses = localState.courses
        .filter((course) =>
          course.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .map((course) => {
          newTitle = course.title.replace(
            new RegExp(searchTerm, "gi"),
            (match) =>
              `<mark style="background: #e7bd3c; color: white;">${match}</mark>`
          );
          return {
            ...course,
            title: newTitle,
          };
        });
    } else {
      filteredCourses = [];
    }

    // Update state with searched course
    return {
      ...state,
      filteredCourses: JSON.parse(JSON.stringify(filteredCourses)),
      coursesLoading: false,
      coursesError: null,
      searchTerm: searchTerm,
    };
  }

  if (action.type === GLOBAL_SEARCH_COURSES_FAILURE) {
    // Set error state
    return {
      ...state,
      coursesLoading: false,
      coursesError: action.payload,
      searchTerm: null,
    };
  }

  if (action.type === SET_USER_REACTION_BEGIN) {
    // Set loading state
    return {
      ...state,
      coursesLoading: action.payload,
      coursesError: null,
    };
  }

  if (action.type === SET_USER_REACTION_SUCCESS) {

    // Update state with user reactions 
    return {
      ...state,
      coursesLoading: false,
      coursesError: null,
    };
  }

  if (action.type === SET_USER_REACTION_FAILURE) {
    // Set error state
    return {
      ...state,
      coursesLoading: false,
      coursesError: action.payload,
    };
  }

  if (action.type === GET_COURSE_USER_REACTION_BEIGN) {
    // Set loading state
    return {
      ...state,
      coursesLoading: action.payload,
      coursesError: null,
    };
  }

  if (action.type === GET_COURSE_USER_REACTION_SUCCESS) {

    let index = (state.courseAllUserReactions || []).findIndex(
      (item) => item.courseId === action.payload.courseId
    );

    let courseAllUserReactions = [...(state.courseAllUserReactions || [])];

    // All userReactions
    if (index === -1) {
      courseAllUserReactions.push({
        courseId: action.payload.courseId,
        userCourseReactions: action.payload.userCourseReactions,
      });
    } else {

      courseAllUserReactions[index] = {
        courseId: action.payload.courseId,
        userCourseReactions: action.payload.userCourseReactions,
      };
    }
    // fetching user reaction count start
    let courseSpecificUserReactions =
      courseAllUserReactions &&
      courseAllUserReactions.length &&
      courseAllUserReactions.map((courseReaction) => {
        let upvoteCountResponse = 0;
        let downvoteCountResponse = 0;
        let loveCountResponse = 0;
        let surprisedCountResponse = 0;

        courseReaction.userCourseReactions.forEach((userReaction) => {
          userReaction.userReactions.forEach((item) => {
            if (item["label"] === "Upvote") {
              upvoteCountResponse += item["count"];
            } else if (item["label"] === "Downvote") {
              downvoteCountResponse += item["count"];
            } else if (item["label"] === "Love") {
              loveCountResponse += item["count"];
            } else if (item["label"] === "Surprised") {
              surprisedCountResponse += item["count"];
            }
          });
        });

        // add to array
        return {
          courseId: courseReaction.courseId,
          courseUserReactionsCount: [
            {
              emoji: "/images/emoji/like.png",
              label: "Upvote",
              count: upvoteCountResponse,
              type: "positive",
            },
            {
              emoji: "/images/emoji/dislike.png",
              label: "Downvote",
              count: downvoteCountResponse,
              type: "negative",
            },
            {
              emoji: "/images/emoji/love.png",
              label: "Love",
              count: loveCountResponse,
              type: "positive",
            },
            {
              emoji: "/images/emoji/surprise.png",
              label: "Surprised",
              count: surprisedCountResponse,
              type: "positive",
            },
          ],
        };
      });

    // Update state with all user reacitons 
    return {
      ...state,
      coursesLoading: false,
      courseAllUserReactions: courseAllUserReactions,
      courseUserReactionsCount: courseSpecificUserReactions,
      coursesError: null,
    };
  }

  if (action.type === GET_COURSE_USER_REACTION_FAILURE) {
    // Set error state
    return {
      ...state,
      coursesLoading: false,
      coursesError: action.payload,
    };
  }

  return state;
};

export default coursesReducer;
